@if (company) {
  <div class="row d-flex">
    <div class="col-lg-6 col-12 d-flex">
      <div class="card mb-5 mb-xl-10 flex-fill" id="kt_profile_details_view">
        <div class="card-header cursor-pointer align-items-center">
          <div class="card-title m-0">
            <h3 class="fw-bold m-0">Company Information</h3>
          </div>
          <app-button
            [iconClass]="'fa fa-edit fs-2'"
            [variant]="'primary'"
            [size]="'md'"
            (clicked)="openEditProfileModal()"
          />
        </div>
        <div class="card-body p-9">
          <div class="row mb-7">
            <label class="col-lg-4 fw-semibold text-muted">Full Name</label>
            <div class="col-lg-8">
              <span class="fw-bold fs-6 text-gray-800">{{ company.company_name }}</span>
            </div>
          </div>
          @if (company.organisation_number) {
            <div class="row mb-7">
              <label class="col-lg-4 fw-semibold text-muted">Organisation number</label>
              <div class="col-lg-8">
                <a href="#" class="fw-semibold fs-6 text-gray-800 text-hover-primary">{{ company.organisation_number }}</a>
              </div>
            </div>
          }
          <div class="row mb-7">
            <label class="col-lg-4 fw-semibold text-muted">Address</label>
            <div class="col-lg-8">
              <a href="#" class="fw-semibold fs-6 text-gray-800 text-hover-primary">{{ company.address }}, {{company.postal_code}} {{company.city}}, {{company.country}}</a>
            </div>
          </div>
          <div class="row mb-7">
            <label class="col-lg-4 fw-semibold text-muted">Active</label>
            <div class="col-lg-8">
              @if (company.active) {
                <span class="badge badge-success">Active</span>
              } @else {
                <span class="badge badge-dark">Inactive</span>
              }
            </div>
          </div>
          <div class="row mb-7">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row d-flex">
    <div class="col-lg-12 col-12 d-flex">
      <div class="card mb-5 mb-xl-10 flex-fill" id="kt_profile_details_view">
        <div class="card-header cursor-pointer align-items-center">
          <div class="card-title m-0">
            <h3 class="fw-bold m-0">Company Description</h3>
          </div>
<!--          <app-button-->
<!--            [iconClass]="'fa fa-edit fs-2'"-->
<!--            [variant]="'primary'"-->
<!--            [size]="'md'"-->
<!--            (clicked)="openEditProfileModal()"-->
<!--          />-->
        </div>
        <div class="card-body p-9" [innerHTML]="company.description"></div>
      </div>
    </div>
  </div>
  <div class="row d-flex">
    <div class="col-lg-12 col-12 d-flex">
      <div class="card mb-5 mb-xl-10 flex-fill" id="kt_profile_details_view">
        <div class="card-header cursor-pointer align-items-center">
          <div class="card-title m-0">
            <h3 class="fw-bold m-0">Images</h3>
          </div>
          <app-button
            [iconClass]="'fa fa-edit fs-2'"
            [variant]="'primary'"
            [size]="'md'"
            (clicked)="openEditImagesModal()"
          />
        </div>
        <div class="card-body p-9">
          <app-carouselorini
            [items]="slides"
            [autoCycle]="true"
            [interval]="8000"
            [showIndicators]="true"
            [showControls]="true"
          ></app-carouselorini>
        </div>
      </div>
    </div>
  </div>
}
